import React from 'react';
import ReactDropdown from 'react-dropdown';

const SortWidget = ({ selected, handle }) => {
  const options = [
    {
      value: 'highest',
      label: 'Highest reach'
    }, {
      value: 'lowest',
      label: 'Lowest reach'
    }
  ];
  return (
    <div className="sort">
      <ReactDropdown onChange={handle} options={options} value={selected} />
      <span>Sort by</span>
    </div>
  );
};
export default SortWidget;



// WEBPACK FOOTER //
// ./src/components/sort-widget/index.js